<template>
  <div class="transaction_h">
    <div class="t_h1">
      <div class="t_h1_top">{{$t('main.text322')}}</div>
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top" :model="form">
          <el-form-item :label="$t('main.text622')">
            <el-input v-model="form.content" :placeholder="$t('main.text623')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('main.text99')" class="riqi_box">
            <el-date-picker
              popper-class="time_box"
              :clearable="false"
              :editable="false"
              v-model="form.time"
              type="daterange"
              :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('main.text324')"
              :end-placeholder="$t('main.text325')">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('main.text316')">
            <el-select v-model="form.status" :placeholder="$t('main.text624')">
              <el-option :label="$t('top_up_dlg.t_status1')" value="1"></el-option>
              <el-option :label="$t('top_up_dlg.t_status2')" value="2"></el-option>
              <el-option :label="$t('top_up_dlg.t_status3')" value="3"></el-option>
              <!-- <el-option :label="$t('top_up_dlg.t_status4')" value="4"></el-option> -->
              <el-option :label="$t('top_up_dlg.t_status5')" value="5"></el-option>
            </el-select>
          </el-form-item>
          
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{$t('main.text329')}}</el-button>
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{$t('main.text330')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="t_h2">
      <div class="t_h2_box">
        <div>
          <div class="t_h2_txt1">{{$t('main.text580')}}</div>
          <!-- <div class="t_h2_txt2"></div> -->
        </div>
        <div>
          <el-button class="export_btn border_set_color2" icon="el-icon-download" size="medium" @click="download_btn">{{$t('main.text333')}}</el-button>
        </div>
      </div>
      <div class="t_h2_table zdy_tab_header">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%">

          <el-table-column
            width="190"
            :label="$t('main.text646')">
            <span slot-scope="props">
              {{overall_time(props.row.c_time)}}
            </span>
          </el-table-column>

          <el-table-column
            :label="$t('main.text567')">
            <span slot-scope="props">
              <div>{{props.row.card_name}}</div>
            </span>
          </el-table-column>

          <el-table-column
            min-width="140"
            :label="$t('main.text658')">
            <span slot-scope="props">
              <div>{{props.row.number}}</div>
            </span>
          </el-table-column>
          

          <el-table-column
            prop="token_type"
            :label="$t('main.text647')">
          </el-table-column>

          <el-table-column :label="$t('main.text648')">
            <span slot-scope="props">
              {{set_num3(props.row.amount)}}
            </span>
          </el-table-column>

          <el-table-column
            :label="$t('main.text316')">
            <span slot-scope="props">
              <!-- 状态: 1成功 2失败(取消) 3processing 4重试 5refund 现在有这几种状态 -->
              <span v-if="props.row.status==1">{{$t('top_up_dlg.t_status1')}}</span>
              <span v-else-if="props.row.status==2" class="color_red">{{$t('top_up_dlg.t_status2')}}</span>
              <span v-else-if="props.row.status==3">{{$t('top_up_dlg.t_status3')}}</span>
              <span v-else-if="props.row.status==4">{{$t('top_up_dlg.t_status4')}}</span>
              <span v-else-if="props.row.status==5">{{$t('top_up_dlg.t_status5')}}</span>
              <span v-else>-</span>
            </span>
          </el-table-column>

          <el-table-column
            :label="$t('main.text665')">
            <span slot-scope="props">
              <!-- 类型 "type": 1 充值 2 年费 3 卡费 4 激活卡的费用 5 手续费 -->
              <span v-if="props.row.type==1">{{$t('main.text666')}}</span>
              <span v-else-if="props.row.type==2">{{$t('main.text503')}}</span>
              <span v-else-if="props.row.type==3">{{$t('main.text667')}}</span>
              <span v-else-if="props.row.type==4">{{$t('main.text668')}}</span>
              <span v-else-if="props.row.type==5">{{$t('main.text669')}}</span>
              <span v-else> - </span>
            </span>
          </el-table-column>

        </el-table>

        <el-pagination
          v-if="tableData.length > 0"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="page_total"
          @current-change="current_change"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {card_topRecord,card_download} from '@/api/api';
export default {
  data() {
    return {
      form:{
        content:"",
        time:'',
        status:''
      },
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: []
    }
  }
  ,
  beforeDestroy(){
    sessionStorage.removeItem('top_title_name');
  },
  mounted() {
    sessionStorage.setItem('top_title_name',this.$t('main.text580'));
    this.get_list();
  },
  methods:{
    get_list(){
      card_topRecord({
        page:this.page,
        limit:this.limit,
        start_date:this.form.time?this.form.time[0]:'',
        end_date:this.form.time?this.form.time[1]:'',
        content:this.form.content,
        status:this.form.status
      }).then(res=>{
        if (res.data.code==200) {
          // console.log(res.data.data);
          this.page_total=res.data.data.count;
          this.tableData=res.data.data.list;
        }
      })
    },
    reset_btn(){
      this.form.time='';
      this.form.content="";
      this.form.status='';
      this.page=1;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    apply_btn(){
      // console.log(this.form);
      this.page=1;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    current_change(v){
      // console.log(v);
      this.page=v;
      this.limit=10;
      this.get_list();
    },
    set_number_4(v){
      if (v) {
        let str1=str1.substr(-4);
        return "•••• •••• ••••"+str1;
      }else{
        return '-';
      }
    },

    download_btn(){
      if (this.page_total<=0) {
        return this.message.ismessage('error',this.$t('main.text335'));
      }
      card_download({
        start_date:this.form.time?this.form.time[0]:'',
        end_date:this.form.time?this.form.time[1]:'',
        content:this.form.content,
        status:this.form.status
      }).then(res=>{
        const filename = res.headers['content-disposition'].split(';')[1].split('=')[1] || 'download.xlsx';
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', `download.xlsx`)
        link.setAttribute('download', `${filename}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }

    
  }
}
</script>

<style scoped>
.t_h1_top{
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box{
  background: #314B69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item{
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select{
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child{
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner{
  background: #223C58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus{
  min-width: 120px;
  border-color: #F1C788;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182A;
}
.zdy_form .btn_box{
  width: auto;
}
.t_h2_box{
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  align-items: center;
}
.t_h2_txt1{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width{
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red{
  color: #F35F65;
}

</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h1_top{
    margin-top: 0;
  }
  .t_h2_box {
    margin-top: 40px;
    align-items: flex-start;
  }

}
</style>
